import getConfig from "next/config";

import { ApolloClient, createHttpLink } from "@apollo/client";
import { InMemoryCache } from "@apollo/client/cache";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { RetryLink } from "@apollo/client/link/retry";

const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();

// https://www.apollographql.com/docs/react/networking/authentication/
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem("fmt-user-token");
  if (token) {
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : "",
      },
    };
  }
  return {
    headers,
  };
});

// https://www.apollographql.com/docs/link/links/error/
const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach((error) => {
      if (error.message !== "Unauthorized") {
        // TODO: notification
      }
    });
  if (networkError) {
    // TODO: notification
  }
});

const retryLink = new RetryLink();

const httpLink = createHttpLink({
  uri:
    publicRuntimeConfig?.NEXT_PUBLIC_GRAPHQL_URL ??
    serverRuntimeConfig?.NEXT_PUBLIC_GRAPHQL_URL ??
    process.env.NEXT_PUBLIC_GRAPHQL_URL,
});

const client = new ApolloClient({
  link: authLink.concat(errorLink).concat(retryLink).concat(httpLink),
  cache: new InMemoryCache({
    addTypename: false,
  }),
  defaultOptions: {
    query: {
      fetchPolicy: "no-cache",
      errorPolicy: "none",
    },
    mutate: {
      fetchPolicy: "no-cache",
      errorPolicy: "none",
    },
  },
});

export default client;
